import Avatar from "@mui/material/Avatar"
import Skeleton from "@mui/material/Skeleton"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { selectProfile, selectProfileLoaded } from "../../pages/users/reducer"

export default function UserAvatar({ width, fontSize }) {
  const userProfile = useSelector(selectProfile)
  const profileLoaded = useSelector(selectProfileLoaded)

  if (profileLoaded) {
    return (
      <Avatar
        sx={{
          width: width,
          height: width,
          fontSize: fontSize,
        }}
        src={userProfile.profile_image ? userProfile.profile_image : undefined}
      >
        {userProfile.profile_image
          ? undefined
          : userProfile.first_name?.[0] ||
            userProfile.email?.[0]?.toUpperCase() ||
            "?"}
      </Avatar>
    )
  } else {
    return <Skeleton variant="circular" width={width} height={width} />
  }
}

UserAvatar.propTypes = {
  width: PropTypes.string,
  fontSize: PropTypes.string,
}
